import { takeLatest, put, call } from "redux-saga/effects";
import { sagaActions } from "../../actions";
import {
  searchHistoryRequests,
  searchHistoryRequestsCompleted,
} from "../../slices/history_requests";
import { workflowsService } from "../../../../../src/core/workflows/workflows_service";

async function handleSearchHistoryRequests({ page, items, filters }) {
  return await workflowsService.listHistoryRequests(page, items, filters);
}

async function handleGetUsers({ tokens, page, items, filters }) {
  return await workflowsService.listUsers(tokens, page, items, filters);
}

function* searchHistoryRequestsSaga({ payload }) {
  try {
    yield put(searchHistoryRequests({ term: payload.filters }));
    const historyRequestsData = yield call(
      handleSearchHistoryRequests,
      payload
    );
    const usersTokens = historyRequestsData.data.map((item) => item.user_token);
    const { data: usersData } = yield call(handleGetUsers, {
      tokens: usersTokens,
      page: 1,
      items: 10,
      filters: {},
    });

    historyRequestsData.data = historyRequestsData.data.map((item) => {
      const user = usersData.find((user) => user.token === item.user_token);
      return {
        ...item,
        fullName: `${user.name} ${user.last_name}`,
      };
    });
    yield put(searchHistoryRequestsCompleted(historyRequestsData));
  } catch (error) {
    console.error(error.message);
  }
}

export function* searchHistoryRequestsWatcherSaga() {
  yield takeLatest(
    sagaActions.START_SEARCH_LIST_HISTORY_REQUESTS,
    searchHistoryRequestsSaga
  );
}
